module.exports = __webpack_public_path__ + "static/media/reloj-de-arena.8847cb5f.gif";